export const getResource = resources => name => resources.find(r => r?.name === name);

export const getResourceImage = resources => (name, fallback) =>
  getResource(resources)(name)?.image || fallback || null;

export const getResourceText = resources => (name, fallback) =>
  getResource(resources)(name)?.text || fallback || null;
